export default __webpack_public_path__ + "static/media/SBI.a8b42fbb.png";